import React from 'react';
import EventTaskView from './task-types/event/EventTaskView';
import EssayTaskPreview from './task-types/essay/EssayTaskPreview';
import { isEventDeliveredTask } from '../../../common/utils/tasks/isEventDeliveredTask';

/**
 * TaskPreviewSelector
 * ------------------
 * Selects an appropriate preview component for the given task type.
 * Falls back to EssayTaskPreview for unknown types.
 */
const TaskPreviewSelector = ({
  task, loading, module, tasks, selectedModule, handleOpenTask, readOnly, ...rest
}) => {
  if (!task) return null;
  const isEventDelivered = isEventDeliveredTask(task);

  const eventTaskViewProps = {
    task,
    loading,
    module,
    tasks,
    selectedModule,
    handleOpenTask,
    resources: task?.resources || [],
    thumbnails: {},
    readOnly,
    ...rest,
  };

  if (isEventDelivered) {
    return <EventTaskView {...eventTaskViewProps} />;
  }

  return (
    <EssayTaskPreview
      task={task}
      loading={loading}
      handleOpenTask={handleOpenTask}
      module={module}
      readOnly={readOnly}
      {...rest}
    />
  );
};

export default TaskPreviewSelector;
